module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card is-large"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(parseInt(_vm.service.integration) === 1 ? _vm.service.booking_id + '/' + _vm.service.service_id : _vm.service.api_booking_id + '/' + _vm.service.api_service_id))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body",
    staticStyle: {
      "height": "200px"
    }
  }, [(_vm.error !== '') ? _c('div', {
    staticClass: "notification is-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "control is-vertical"
  }, [_c('div', {
    staticClass: "control is-grouped"
  }, [_c('p', {
    staticClass: "control is-expanded"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Invoice")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.invoice),
      expression: "invoice"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "name": "invoice",
      "id": "invoice"
    },
    domProps: {
      "value": (_vm.invoice)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.invoice = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('div', {
    staticClass: "control is-grouped is-pulled-right"
  }, [_c('p', {
    staticClass: "control is-pulled-right"
  }, [_c('a', {
    staticClass: "button is-primary",
    on: {
      "click": function($event) {
        return _vm.close(true)
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    class: {
      'button': true,
      'is-success': true,
      'is-disabled': _vm.errors.any() || _vm.inProgress || _vm.invoice == null,
      'is-loading': _vm.inProgress
    },
    on: {
      "click": function($event) {
        return _vm.add()
      }
    }
  }, [_vm._v("Add")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6aa9f6c7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/finances/AddServiceInvoice.vue
// module id = 1152
// module chunks = 39